import Toasted from 'vue-toasted';
import alignWithAppWidth from '@/utils/align-with-app-width';

// TODO: This is a huge hack. Ideally we would patch the library to allow
// dynamic positioning of the toast element.
function alignToastWithContainer(Vue) {
  const prevShow = Vue.toasted.show;

  Vue.toasted.show = (...args) => {
    const toast = prevShow(...args);

    // The toast library has some default styles that already position things
    // nicely on small devices.
    if (window.innerWidth <= 600) {
      return;
    }

    alignWithAppWidth(document.querySelector('.toasted-container'));

    return toast;
  };
}

export default function (Vue) {
  Vue.use(Toasted, {
    duration: 5000,
    className: 'toast-override', // See `_overrides.scss`
    iconPack: 'fontawesome',
  });

  alignToastWithContainer(Vue);
}
